if (!customElements.get("cian-content-mini-gallery")) customElements.define("cian-content-mini-gallery", class extends HTMLElement {
    selectPhoto = (num) => {
        const images = this.querySelectorAll('img');
        for (let i = 0; i < images.length; i++) {
            images.item(i).setAttribute("visible", i === num ? "true" : "false");
            const selector = '[dash_' + (i + 1) + ']';
            const elements = this.querySelectorAll(selector);
            elements.forEach((element) => {
                element.setAttribute("selected", i === num ? "true" : "false")
            })
        }
        const pictureCount = Number.parseInt(this.getAttribute("total_pictures") || "0");
        const splash = this.querySelector('[view_more_splash]');
        if (splash) splash.setAttribute('visible', pictureCount > 5 && num === 4);
    };

    connectedCallback() {
        let cacheUrl = false;
        let renderUrl = false;
        if (this.hasAttribute('jk-ref')) {
            const jkRef = this.getAttribute('jk-ref');
            const id = /-([0-9]+)[^0-9]*$/.exec(jkRef)[1];
            cacheUrl = `https://cdn.cian.site/finance/content-distribution/jk/${id}.json`;
            renderUrl = `https://content-distribution-photogallery-service.content.cian.ru/api/v1/jk/&?jk_name=${encodeURIComponent(jkRef)}`;
        }
        if (this.hasAttribute('offer-id')) {
            const id = this.getAttribute('offer-id');
            cacheUrl = `https://cdn.cian.site/finance/content-distribution/flat-photo/${id}.json`;
            renderUrl = `https://content-distribution-photogallery-service.content.cian.ru/api/v1/flat/${id}`;
        }
        console.log({cacheUrl, renderUrl})
        fetch(cacheUrl).then((result) => {
            console.log(result);
            if (result.ok) {
                return result.json();
            }
            return fetch(renderUrl).then((result) => {
                console.log(result);
                if (result.ok) {
                    return result.json();
                }
                return [];
            })
        }).catch(() => fetch(renderUrl).then((result) => {
                console.log(result);
                if (result.ok) {
                    return result.json();
                }
                return [];
            })
        ).then((photos) => {
            console.log(photos);
            if (photos.length > 0) {
                const imgs =
                    `<img style="object-fit: cover; height: 100%; width: 100%; margin: auto; border-radius: 4px; box-shadow: 0px 5px 15px rgba(38, 44, 64, 0.15);" src="${photos[0].mobileUrl}">` +
                    photos.slice(1, 5).map(p => `<img loading="lazy" style="object-fit: cover; height: 100%; width: 100%; margin: auto; display: none; border-radius: 4px; box-shadow: 0px 5px 15px rgba(38, 44, 64, 0.15);" src="${p.mobileUrl}">`).join('\n');
                this.innerHTML = `
                <div style="visibility: hidden; position: absolute; width: 179px;height: 36px;left: 107px;top: 0px;background: rgba(255, 255, 255, 0.55);backdrop-filter: blur(10px);border-radius: 0px 0px 4px 4px; display: flex; justify-content: center;align-items: center;">
                    <svg width="120" height="20" viewBox="0 0 120 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M35.4325 15H33.5605V5.976H28.0085V15H26.1365V4.328H35.4325V15ZM36.851 15.192V13.816C37.1817 13.816 37.443 13.6027 37.635 13.176C37.8377 12.7493 38.003 12.0347 38.131 11.032L38.595 7.272H44.563V15H42.883V8.744H40.083L39.811 11.224C39.6617 12.6107 39.347 13.6187 38.867 14.248C38.387 14.8773 37.715 15.192 36.851 15.192ZM53.1447 15H51.4647V14.168C50.8674 14.8507 50.0354 15.192 48.9687 15.192C48.2647 15.192 47.6407 14.968 47.0967 14.52C46.5527 14.0613 46.2807 13.432 46.2807 12.632C46.2807 11.8107 46.5474 11.1867 47.0807 10.76C47.6247 10.3333 48.2541 10.12 48.9687 10.12C50.0674 10.12 50.8994 10.4507 51.4647 11.112V9.96C51.4647 9.512 51.2994 9.16 50.9687 8.904C50.6381 8.648 50.2007 8.52 49.6567 8.52C48.7927 8.52 48.0301 8.84533 47.3687 9.496L46.6807 8.328C47.5554 7.496 48.6381 7.08 49.9287 7.08C50.8781 7.08 51.6514 7.304 52.2487 7.752C52.8461 8.2 53.1447 8.90933 53.1447 9.88V15ZM49.6247 14.04C50.4674 14.04 51.0807 13.7733 51.4647 13.24V12.072C51.0807 11.5387 50.4674 11.272 49.6247 11.272C49.1447 11.272 48.7501 11.4 48.4407 11.656C48.1314 11.912 47.9767 12.248 47.9767 12.664C47.9767 13.08 48.1314 13.416 48.4407 13.672C48.7501 13.9173 49.1447 14.04 49.6247 14.04ZM57.0029 15H55.3229V7.272H57.0029V10.312H60.5549V7.272H62.2349V15H60.5549V11.784H57.0029V15ZM66.0326 15H64.4166V7.272H66.0966V12.472L69.6486 7.272H71.3286V15H69.6486V9.656L66.0326 15ZM77.6704 15.192C76.6464 15.192 75.8197 14.7707 75.1904 13.928V17.944H73.5104V7.272H75.1904V8.328C75.809 7.496 76.6357 7.08 77.6704 7.08C78.6837 7.08 79.505 7.44267 80.1344 8.168C80.7744 8.89333 81.0944 9.88 81.0944 11.128C81.0944 12.376 80.7744 13.368 80.1344 14.104C79.505 14.8293 78.6837 15.192 77.6704 15.192ZM77.1744 13.704C77.8357 13.704 78.3637 13.464 78.7584 12.984C79.153 12.504 79.3504 11.8853 79.3504 11.128C79.3504 10.3707 79.153 9.75733 78.7584 9.288C78.3637 8.808 77.8357 8.568 77.1744 8.568C76.7904 8.568 76.4117 8.66933 76.0384 8.872C75.665 9.07467 75.3824 9.32 75.1904 9.608V12.664C75.3824 12.952 75.665 13.1973 76.0384 13.4C76.4117 13.6027 76.7904 13.704 77.1744 13.704ZM86.2484 15.192C85.0537 15.192 84.0937 14.8027 83.3684 14.024C82.643 13.2347 82.2804 12.2693 82.2804 11.128C82.2804 9.98667 82.643 9.02667 83.3684 8.248C84.0937 7.46933 85.0537 7.08 86.2484 7.08C87.4537 7.08 88.419 7.46933 89.1444 8.248C89.8697 9.02667 90.2324 9.98667 90.2324 11.128C90.2324 12.28 89.8697 13.2453 89.1444 14.024C88.419 14.8027 87.4537 15.192 86.2484 15.192ZM86.2484 13.704C86.9417 13.704 87.4857 13.4587 87.8804 12.968C88.2857 12.4667 88.4884 11.8533 88.4884 11.128C88.4884 10.4133 88.2857 9.81067 87.8804 9.32C87.4857 8.81867 86.9417 8.568 86.2484 8.568C85.5657 8.568 85.0217 8.81867 84.6164 9.32C84.2217 9.81067 84.0244 10.4133 84.0244 11.128C84.0244 11.8533 84.2217 12.4667 84.6164 12.968C85.0217 13.4587 85.5657 13.704 86.2484 13.704ZM96.6682 15H91.9322V7.272H96.5562C97.2709 7.272 97.8309 7.45867 98.2362 7.832C98.6416 8.20533 98.8442 8.68 98.8442 9.256C98.8442 9.704 98.7216 10.0827 98.4762 10.392C98.2309 10.7013 97.9216 10.9093 97.5482 11.016C97.9642 11.112 98.3109 11.3413 98.5882 11.704C98.8656 12.056 99.0042 12.456 99.0042 12.904C99.0042 13.5227 98.7962 14.0293 98.3802 14.424C97.9749 14.808 97.4042 15 96.6682 15ZM96.3162 13.528C96.6149 13.528 96.8496 13.4533 97.0202 13.304C97.1909 13.144 97.2762 12.9307 97.2762 12.664C97.2762 12.4187 97.1909 12.2107 97.0202 12.04C96.8496 11.8693 96.6149 11.784 96.3162 11.784H93.6122V13.528H96.3162ZM96.2682 10.312C96.5349 10.312 96.7429 10.2427 96.8922 10.104C97.0522 9.95467 97.1322 9.768 97.1322 9.544C97.1322 9.29867 97.0522 9.10667 96.8922 8.968C96.7429 8.81867 96.5349 8.744 96.2682 8.744H93.6122V10.312H96.2682ZM108.32 15H106.208L103.84 11.816L102.768 12.92V15H101.088V7.272H102.768V11L106.176 7.272H108.256L105.04 10.776L108.32 15ZM115.91 15H114.23V14.168C113.633 14.8507 112.801 15.192 111.734 15.192C111.03 15.192 110.406 14.968 109.862 14.52C109.318 14.0613 109.046 13.432 109.046 12.632C109.046 11.8107 109.313 11.1867 109.846 10.76C110.39 10.3333 111.02 10.12 111.734 10.12C112.833 10.12 113.665 10.4507 114.23 11.112V9.96C114.23 9.512 114.065 9.16 113.734 8.904C113.404 8.648 112.966 8.52 112.422 8.52C111.558 8.52 110.796 8.84533 110.134 9.496L109.446 8.328C110.321 7.496 111.404 7.08 112.694 7.08C113.644 7.08 114.417 7.304 115.014 7.752C115.612 8.2 115.91 8.90933 115.91 9.88V15ZM112.39 14.04C113.233 14.04 113.846 13.7733 114.23 13.24V12.072C113.846 11.5387 113.233 11.272 112.39 11.272C111.91 11.272 111.516 11.4 111.206 11.656C110.897 11.912 110.742 12.248 110.742 12.664C110.742 13.08 110.897 13.416 111.206 13.672C111.516 13.9173 111.91 14.04 112.39 14.04Z"
                              fill="#0066CC"/>
                        <rect x="10.0005" y="3" width="5" height="10" stroke="#0066CC" stroke-width="2"/>
                        <rect x="10.0005" y="9" width="5" height="4" stroke="#0066CC" stroke-width="2"/>
                        <rect x="1.00049" y="3" width="9" height="14" stroke="#0066CC" stroke-width="2"/>
                    </svg>
                </div>
                <div style="z-index: 2;position: absolute;width: calc(100% - 30px);height: 4px;left: 15px;bottom: 15px;display: grid; grid-template-columns: repeat(5, 1fr); grid-column-gap: 4px">
                    <div dash_1
                         style="background: #FFFFFF !important;opacity: 0.9;border-radius: 4px;"></div>
                    <div dash_2
                         style="background: #FFFFFF !important;opacity: 0.3;border-radius: 4px;"></div>
                    <div dash_3
                         style="background: #FFFFFF !important;opacity: 0.3;border-radius: 4px;"></div>
                    <div dash_4
                         style="background: #FFFFFF !important;opacity: 0.3;border-radius: 4px;"></div>
                    <div dash_5
                         style="background: #FFFFFF !important;opacity: 0.3;border-radius: 4px;"></div>
                </div>
                ${imgs}
                <div visible="false" view_more_splash>
                    <div style="backdrop-filter: blur(10px); background: #FFFFFF; opacity: 0.6; position: absolute; width: 100%; height: 100%; text-align: center; vertical-align: center; top: 0; left: 0; justify-content: center; align-items: center"></div>
                    <div style="display: flex; backdrop-filter: blur(10px); position: absolute; width: 100%; height: 100%; text-align: center; vertical-align: center; top: 0; left: 0; justify-content: center; align-items: center">
                        <div>Посмотреть еще фото</div>
                    </div>
                </div>
            `;
            } else {
                this.innerHTML = `
                    <div style="border-radius: 2px; height: 100%;width: 100%;display: flex; justify-content: center; align-items: center; background-color: #F7F9FB;">
                        <div style="font-size: 16px;line-height: 20px;color: #7C8793;">Нет фото</div>
                    </div>
                `
            }
            this.init();
        });

    }

    init() {
        const styleElement = document.createElement('style');
        styleElement.innerHTML = `
            cian-content-mini-gallery [visible="false"] {
                display: none;
            }
            
            cian-content-mini-gallery [visible="true"] {
                display: flex !important;
            }
            
            cian-content-mini-gallery [selected="true"] {
                opacity: 0.9 !important;
            }
            cian-content-mini-gallery [selected="false"] {
                opacity: 0.3 !important;
            }
        `;
        document.head.appendChild(styleElement);
        const init = () => {
            const images = this.querySelectorAll('img');
            //hide all bar if images < 5
            for (let i = images.length; i < 5; i++) {
                const selector = '[dash_' + (i + 1) + ']';
                const elements = this.querySelectorAll(selector);
                elements.forEach((element) => {
                    element.setAttribute("visible", "false")
                });
            }
        };
        if (document.readyState === 'loading')
            document.addEventListener('DOMContentLoaded', init);
        else
            init();

        this.addEventListener('mousemove', (e) => {
            const images = this.querySelectorAll('img');
            const rect = this.getBoundingClientRect();
            const x = e.clientX - rect.x;
            const width = rect.width;
            const part = width / 5;
            let num = 0;
            if (x >= width) {
                num = images.length - 1;
            } else if (x < 0) {
                num = 0;
            } else {
                num = Math.min(images.length - 1, Math.floor(x / part));
            }
            this.selectPhoto(num)
        });

        this.addEventListener('mouseleave', (e) => {
            this.selectPhoto(0)
        });
    };
});
